import { render, staticRenderFns } from "./topTendersMessage.vue?vue&type=template&id=b7f7cbe2&scoped=true"
import script from "./topTendersMessage.vue?vue&type=script&lang=js"
export * from "./topTendersMessage.vue?vue&type=script&lang=js"
import style0 from "./topTendersMessage.vue?vue&type=style&index=0&id=b7f7cbe2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f7cbe2",
  null
  
)

export default component.exports